export default {"src":"https://webcdn.trailways.ca/_next/static/media/credit-card.d59ef2ec.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};